var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page page-details page-material-details" }, [
    _c("div", { staticClass: "material_preview_dialog_left" }, [
      _c("div", { staticClass: "viewcontainer" }, [
        _vm.materialViewDialog.type == 1
          ? _c(
              "div",
              { staticClass: "img_wrap" },
              [
                _c(
                  "viewer",
                  { attrs: { images: [_vm.materialViewDialog.url] } },
                  _vm._l([_vm.materialViewDialog.url], function(src, i) {
                    return _c("img", { key: i, attrs: { src: src } })
                  }),
                  0
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.materialViewDialog.type == 2
          ? _c(
              "div",
              {
                class: "pdf_wrap " + _vm.pdfEnlargStyle + " " + _vm.pageStyle,
                style:
                  "height:" +
                  (_vm.pdfEnlargStyle == ""
                    ? _vm.windowHeight - 30
                    : _vm.windowHeight) +
                  "px"
              },
              [
                _c("pdf", {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading"
                    }
                  ],
                  ref: "pdf",
                  staticClass: "myPDF",
                  attrs: {
                    src: _vm.materialViewDialog.url,
                    page: _vm.pageNum,
                    rotate: _vm.pageRotate
                  },
                  on: {
                    password: _vm.password,
                    progress: function($event) {
                      _vm.loadedRatio = $event
                    },
                    "page-loaded": function($event) {
                      return _vm.pageLoaded($event)
                    },
                    "num-pages": function($event) {
                      _vm.pageTotalNum = $event
                    },
                    error: function($event) {
                      return _vm.pdfError($event)
                    },
                    "link-clicked": function($event) {
                      _vm.page = $event
                    }
                  }
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass: "el-icon-arrow-left btn-def btn-pre",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.prePage.apply(null, arguments)
                    },
                    dblclick: function($event) {
                      $event.stopPropagation()
                    }
                  }
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass: "el-icon-arrow-right btn-def btn-next",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.nextPage.apply(null, arguments)
                    },
                    dblclick: function($event) {
                      $event.stopPropagation()
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "pdfCurrentPage" }, [
                  _vm._v(_vm._s(_vm.pageNum) + "/" + _vm._s(_vm.pageTotalNum))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "operating_btn" }, [
                  _c("div", [
                    _vm.pdfEnlargeSign == 1
                      ? _c("i", {
                          staticClass: "el-icon-zoom-in",
                          on: {
                            click: _vm.pdfEnlargeBtn,
                            dblclick: function($event) {
                              $event.stopPropagation()
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.pdfEnlargeSign == 2
                      ? _c("i", {
                          staticClass: "el-icon-zoom-out",
                          on: {
                            click: _vm.pdfNarrowBtn,
                            dblclick: function($event) {
                              $event.stopPropagation()
                            }
                          }
                        })
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div")
                ])
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.materialViewDialog.type == 3
          ? _c("div", { staticClass: "video_wrap" }, [
              _c("audio", {
                staticClass: "audio",
                attrs: { src: _vm.materialViewDialog.url, controls: "controls" }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.materialViewDialog.type == 4
          ? _c("div", { staticClass: "video_wrap" }, [
              _c(
                "video",
                {
                  ref: "video",
                  staticClass: "video",
                  attrs: {
                    id: "video1",
                    controls: "",
                    controlsList: "nodownload",
                    muted: "muted",
                    preload: "auto",
                    "data-setup": '{"example_option":true}',
                    height: "500"
                  },
                  domProps: { muted: true }
                },
                [
                  _c("source", {
                    staticClass: "video",
                    attrs: {
                      id: "sourceBox",
                      src: _vm.materialViewDialog.url,
                      type: "video/mp4"
                    }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "vjs-no-js" }, [_vm._v("不支持播放")])
                ]
              )
            ])
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "material_preview_dialog_right" },
      [
        _c("ul", [
          _c("li", [
            _c("p", [_vm._v("素材名称：")]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.materialForm.materialName))])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [_vm._v("分类：")]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.materialForm.materialsort))])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [_vm._v("上传人：")]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.materialForm.createUseStr))])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [_vm._v("上传时间：")]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.materialForm.uploadTime))])
          ])
        ]),
        _vm._v(" "),
        _c("el-button", { on: { click: _vm.handleGoBack } }, [_vm._v("返 回")])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ed828c10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed828c10","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/course/materialDetails.vue
// module id = null
// module chunks = 